module.exports = __webpack_public_path__ + "img/rule-5-wobler.855c8cb2.png";